import { Button, useConnectWalletModal, useSwitchToConfiguredChain } from '@airdao/ui-library';

import { useAccount } from 'wagmi';

const ConnectBlock = () => {
  const { address: account, chainId } = useAccount();
  const isInvalidChain =
    process.env.REACT_APP_CHAIN_ID === chainId?.toString() || !account;

  const { toggleModal } = useConnectWalletModal();
  const switchToAmb = useSwitchToConfiguredChain();

  return (
    <div className="page-rewards">
      <div className="connect-block">
        <div className="connect-block__inner">
          <h4 className="connect-block__inner-title">
            Stake, Trade, Earn Rewards!
          </h4>
          <p className="connect-block__inner-text">
            Connect Your Wallet and Begin Your Journey
          </p>
          <Button
            onClick={isInvalidChain ? toggleModal : switchToAmb}
            type="secondary"
            size="large"
          >
            {isInvalidChain ? 'Connect wallet' : 'Switch to AMB-NET'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConnectBlock;
